// extracted by mini-css-extract-plugin
export default {"Keyboard":"Keyboard_Keyboard__y3NVa","keyboardRow":"Keyboard_keyboardRow__Ou2wz","Keys":"Keyboard_Keys__lFCTS"};